module.exports = "<h1 class=\"bluetext\" style=\"text-align: center\">403 - Access Forbidden Error</h1>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/users/forbidden.component.html
// module id = ./src/app/users/forbidden.component.html
// module chunks = main